import { LoaderFunctionArgs, redirect, useLoaderData } from "react-router";
import { useEffect } from "react";
import { ChannelList, MessageList } from "#components/discord";
import {
  fetchDiscordMessages,
  fetchDiscordMessageSeq,
  fetchDiscordServer,
  groupMessages,
  IDiscordChannel,
  IDiscordMessageGroup,
  IDiscordServer
} from "#api/discord";
import { createDiscordChannelPageURL } from "#lib/urls";

import * as styles from "#components/discord/styles.module.scss";

interface IProps {
  server: IDiscordServer;
  channel: IDiscordChannel;
  messages: IDiscordMessageGroup[];
  messageId?: string;
  offset: number;
}

export function DiscordPage() {
  const { server, channel, messages, messageId, offset } = useLoaderData<IProps>();

  useEffect(() => {
    // todo: not this
    let main = document.getElementById("main");
    if (main) {
      main.style.padding = "0";
    }
    let footer = document.getElementsByClassName("global-footer")[0] as HTMLElement;
    if (footer) {
      footer.style.display = "none";
    }

    return () => {
      if (main) {
        main.style.padding = "";
      }
      if (footer) {
        footer.style.display = "";
      }
    }
  }, []);

  useEffect(() => {
    if (messageId) {
      window.history.pushState(null, "", `#message-${messageId}`);
      document.getElementById(`message-${messageId}`)?.scrollIntoView();
    }
  }, [messageId]);

  return (
    <section className={styles.discord}>
      <ChannelList server={server} selectedChannel={channel} offset={offset} />

      <MessageList messages={messages} messageId={messageId} />
    </section>
  );
}

export async function loader({ request, params }: LoaderFunctionArgs): Promise<IProps | Response> {
  const serverId = params.serverId!;
  const channelId = params.channelId;
  const messageId = params.messageId;
  const offset = Number(new URL(request.url).searchParams.get("o")) || 0;

  const server = await fetchDiscordServer(serverId);

  if (!server.channels.length) {
    throw new Error("No channels found");
  }

  const channel = server.channels.find(c => c.id == channelId) ?? server.channels[0];

  if (channelId && messageId) {
    let { seq } = await fetchDiscordMessageSeq(channelId, messageId);

    if (seq) {
      let wantedOffset = Math.floor((channel.post_count - seq) / 150) * 150;

      if (offset != wantedOffset) {
        return redirect(String(createDiscordChannelPageURL(serverId, channelId, messageId, wantedOffset)));
      }
    }
  }

  if (!channelId || channel.id != channelId) {
    return redirect(String(createDiscordChannelPageURL(server.id, server.channels[0].id, undefined, offset)));
  }

  // Stupid bullshit to account for "seq" field lookup. The first page likely will not have 150 posts,
  // because of the offset having to be a multiple of 150 (thus first page will have post_count % 150 posts).
  const realOffset = Math.floor((channel.post_count - offset) / 150) * 150;
  const messages = await fetchDiscordMessages(channelId, realOffset).then(groupMessages);

  return {
    server,
    channel,
    messages,
    messageId,
    offset,
  };
}
